import React from 'react';
import { FaCircle, FaClock, FaCalendarAlt } from 'react-icons/fa';
import { Section, SectionTitle, InfoGrid, InfoItem } from './ProfileStyles';

/**
 * Componente para exibir o status da conta do usuário
 *
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.ativo - Se a conta está ativa
 * @param {string} props.ultimoLogin - Data/hora do último login (ISO string)
 * @param {string} props.dataCadastro - Data/hora do cadastro (ISO string)
 *
 * @returns {JSX.Element} Seção com status da conta
 */
export const AccountStatus = ({ ativo, ultimoLogin, dataCadastro }) => (
  <Section>
    <SectionTitle>
      <FaCircle /> Status da Conta
    </SectionTitle>

    <InfoGrid>
      <InfoItem>
        <label>Situação</label>
        <span>{ativo ? 'Ativo' : 'Inativo'}</span>
      </InfoItem>

      <InfoItem>
        <label><FaClock /> Último acesso</label>
        <span>
          {ultimoLogin
            ? new Date(ultimoLogin).toLocaleString('pt-BR')
            : 'Não informado'}
        </span>
      </InfoItem>

      <InfoItem>
        <label><FaCalendarAlt /> Cadastrado desde</label>
        <span>
          {dataCadastro
            ? new Date(dataCadastro).toLocaleDateString('pt-BR')
            : 'Não informado'}
        </span>
      </InfoItem>
    </InfoGrid>
  </Section>
);
